import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "UG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#UG_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "UG_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#UG_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#272727", d: "M0 0h32v4H0z" }), /* @__PURE__ */ e.createElement("path", { fill: "#D74800", d: "M0 8h32v4H0z" }), /* @__PURE__ */ e.createElement("path", { fill: "#272727", d: "M0 12h32v4H0z" }), /* @__PURE__ */ e.createElement("path", { fill: "#D74800", d: "M0 20h32v4H0z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 18a6 6 0 100-12 6 6 0 000 12z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.68 8.33l-1.058.346 1.058.09s.171.42 0 .746c-.043.083-.155.189-.298.324-.42.399-1.108 1.051-1.108 2.11 0 1.42 2.74 2.065 2.74 2.065v.674s.319.198-1.496.198c-1.574 0-1.476.597-1.422.924.008.05.016.094.016.128 0 .259.756-.258 1.11-.772.187-.27.967-.256 1.768-.182.063.006.648 1.243.14 1.882-.213.269-.948.304-1.408.326-.234.01-.397.019-.382.052.012.025.15.017.352.005.251-.015.6-.036.923-.005.049.005-.141.17-.333.336-.197.171-.397.344-.34.347.063.003.432-.202.768-.388.278-.154.533-.295.571-.295.254 0 .483.031.683.059.336.046.592.08.754-.059.05-.043-.239-.112-.533-.183-.303-.072-.613-.146-.564-.195.279-.276.162-.856.07-1.313-.04-.205-.077-.385-.07-.502.024-.414.463-.197.808-.026.15.075.284.141.356.141.653 0-.158-.826-.603-1.28-.04-.039-.075-.076-.107-.109-.227-.234-.068-.202.29-.131.275.054.665.131 1.09.131.98 0 1.697-.319 1.448-1.181-.164-.57-1.063-.764-2.001-.966-.485-.104-.98-.211-1.39-.373-1.009-.398-.958-.978-.914-1.468.008-.096.017-.188.017-.274 0-.532.897-1.183.897-1.183s-.41-.686-1.089-.686c-.68 0-.743.686-.743.686zm1.85 6.246v-.501s.419-.014.566.339c.147.353-.567.162-.567.162z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.078 6.711l1.014 1.202.525-.123-.252-1.214-1.287.135z",
      fill: "#D74800"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.394 6.42l.065 1.808.866-.213.368-1.184-1.299-.41z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.577 9.439a.342.342 0 00.346-.338.342.342 0 00-.346-.337.342.342 0 00-.347.337c0 .187.155.338.347.338zM15.777 6.76L14.77 7.967l.212.495 1.152-.458-.357-1.244zM18.12 15.893s1.773-.792 1.773-1.899-2.878-2.313-2.878-2.313-1.693.387-.93.906c.763.518 1.785.717 1.785 1.407 0 .69.28 1.348-.288 1.348-.567 0 .538.551.538.551z",
      fill: "#D74800"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.561 11.479s-.627.11-.597.212c.082.28.94.647 1.313.901.763.519 1.487.46 2.025.123.538-.337-2.74-1.236-2.74-1.236z",
      fill: "#FFFDFF"
    }
  )))
), a = t;
export {
  a as default
};
